import * as React from "react";
import "./tab.component.css";
import { useEffect, useMemo, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconSearch,
  IconTrash,
  IconEdit,
  IconPlus,
  IconActivity,
  IconStatusChange,
  IconTimeDuration15,
  IconUserCode,
  IconCheck,
  IconHandStop,
  IconLockOpen,
  IconLockDown,
  IconPassword,
  IconPasswordUser,
  IconPencilUp,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Select,
  SelectProps,
  Title,
  Tooltip,
} from "@mantine/core";
import { _localization } from "../../config/location";

import { modals } from "@mantine/modals";
import { DatePickerInput } from "@mantine/dates";
import {
  pageTable,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { useForm } from "@mantine/form";
import { ListUserSearchModel } from "../../model/BaseSearchModel";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { SelectListItem } from "../../model/SelectListItem";
import { getDepartmentSelect } from "../../const/getSelectApi";
import UserDeleteView from "./UserDeleteView";
import { UserMode } from "../../model/UserMode";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import UserCreateView from "./UserCreateView";
import UserEditView from "./UserEditView";
import UserChangPass from "./UserChangPass";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";

const UserTable = () => {
  const [data, setData] = useState<UserMode[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  // Table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [dataListDepartment, setDataListDepartment] = useState<
    SelectListItem[]
  >([]);
  const _span = { base: 6, sm: 4, md: 4, lg: 3, xl: 2.5 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: ListUserSearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListUserSearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        keySearch: form.getValues().keySearch,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        departmentId: form.getValues().departmentId,
        roleId: form.getValues().roleId,
      };

      const baseUrl = "/api/v1/Users/get-list";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<MessageResponse<UserMode[]>>(
        url
      );

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchDataDepartment = async () => {
    const dataApi = await getDepartmentSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListDepartment(filteredData);
    }
  };

  const departmentMap = useMemo(() => {
    const map = new Map<number, string>();
    dataListDepartment.forEach((dep) => {
      map.set(Number(dep.value), dep.text);
    });
    return map;
  }, [dataListDepartment]);

  // useEffect(() => {
  //   if (dataUpdated) {
  //     const updatedData = data.map((item) => ({
  //       ...item,
  //       departmentName: departmentMap.get(item.departmentId ?? 0) || "",
  //     }));
  //     setData(updatedData);
  //     setDataUpdated(false);
  //   }
  // }, [data, dataUpdated, departmentMap]);

  const handleDeleteEmployee = async (ids: number[]) => {
    modals.openConfirmModal({
      title: "",
      children: (
        <UserDeleteView ids={ids} onSearch={fetchData} onClose={setOpenModal} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // const handleCreatePartner = async () => {
  //   modals.openConfirmModal({
  //     title: "Tạo mới đối tác",
  //     size: "auto",
  //     children: <PartnersCreateView onClose={fetchData} />,
  //     confirmProps: { display: "none" },
  //     cancelProps: { display: "none" },
  //   });
  // };

  // const handleUpdatePartner = async (id: number) => {
  //   modals.openConfirmModal({
  //     title: "",
  //     size: "auto",
  //     children: <PartnersEditView id={id} onClose={fetchData} />,
  //     confirmProps: { display: "none" },
  //     cancelProps: { display: "none" },
  //   });
  // };

  const handleActiveEmployee = async ({ status }: { status: boolean }) => {
    try {
      let url = "/api/v1/Employee/update-active";
      const response = await repositorySign.post<MessageResponse<boolean>>(
        url,
        {
          ids: selectIds,
          status,
        }
      );

      if (response?.success) {
        await fetchData();
        NotificationExtension.Success(
          status
            ? "Kích hoạt người dùng thành công !"
            : "Ngừng kích hoạt người dùng thành công !"
        );
      } else {
        NotificationExtension.Fails(
          status
            ? "Kích hoạt người dùng thất bại !"
            : "Ngừng kích hoạt người dùng thất bại !"
        );
      }
    } catch (e) {
      console.log(e);
      return;
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<UserMode>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "name",
        header: "Họ tên",
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              color={renderedCellValue === true ? "green" : "red"}
              variant="light"
              radius="sm"
            >
              {renderedCellValue === true ? "Hoạt động" : "Ngừng hoạt động"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "userName",
        header: "Tên đăng nhập",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "departmentName",
        header: "Đơn vị",
      },
      {
        accessorKey: "roleName",
        header: "Vai trò",
      },

      {
        accessorKey: "updatedAt",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Tooltip label="Chỉnh sửa thông tin">
              <ActionIcon
                onClick={() => {
                  modals.openConfirmModal({
                    title: <Title order={4}>Chỉnh sửa</Title>,
                    children: (
                      <UserEditView id={row.original.id} onClose={fetchData} />
                    ),
                    size: "50%",
                    confirmProps: { display: "none" },
                    cancelProps: { display: "none" },
                  });
                }}
                variant="light"
                aria-label="Settings"
                color="cyan"
              >
                <IconEdit size={14} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Thay đổi mật khẩu">
              <ActionIcon
                onClick={async () => {
                  modals.openConfirmModal({
                    title: "Thay đổi mật khẩu",
                    children: (
                      <UserChangPass id={row.original.id} onClose={fetchData} />
                    ),
                    labels: { confirm: "Xác nhận", cancel: "Hủy bỏ" },
                    size: "500px",
                    confirmProps: { display: "none" },
                    cancelProps: { display: "none" },
                  });
                }}
                variant="light"
                aria-label="Settings"
                color="indigo"
              >
                <IconPasswordUser size={14} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip
              label={
                row.original.status === true
                  ? "Khóa tài khoản"
                  : "Mở khóa tài khoản"
              }
            >
              <ActionIcon
                onClick={async () => {
                  const url = "/api/v1/users/actives";
                  const result = await repositorySign.post<
                    MessageResponse<boolean>
                  >(url, {
                    ids: [row.original.id],
                    status: !row.original.status,
                  });
                  if (result && result.httpStatusCode === 200) {
                    if (result.success) {
                      await fetchData();
                      NotificationExtension.Success("Thành công !");
                    } else
                      NotificationExtension.Fails(
                        result.message.length > 0
                          ? result.message
                          : "Thất bại !"
                      );
                    //   setDisabledBtn(false);
                  }
                }}
                variant="light"
                aria-label="Settings"
                color={row.original.status === true ? "cyan" : "grape"}
              >
                {row.original.status === true ? (
                  <IconLockDown size={14} stroke={1.5} />
                ) : (
                  <IconLockOpen size={14} stroke={1.5} />
                )}
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                onClick={async () => {
                  modals.openConfirmModal({
                    title: "Xóa",
                    children: <>Bạn có thực sự muốn thao tác xóa !</>,
                    labels: { confirm: "Xác nhận", cancel: "Hủy bỏ" },
                    onCancel: () => console.log("Cancel"),
                    onConfirm: async () => {
                      const url = "/api/v1/users/delete";
                      const result = await repositorySign.post<
                        MessageResponse<boolean>
                      >(url, [row.original.id]);
                      if (result && result.httpStatusCode === 200) {
                        if (result.success) {
                          await fetchData();
                          NotificationExtension.Success("Thành công !");
                        } else
                          NotificationExtension.Fails(
                            result.message.length > 0
                              ? result.message
                              : "Thất bại !"
                          );
                        //   setDisabledBtn(false);
                      }
                    },
                  });
                }}
                variant="light"
                aria-label="Settings"
                color="red"
              >
                <IconTrash size={14} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  //Thêm mới
  const handleCreateUser = () => {
    modals.openConfirmModal({
      title: <Title order={4}>Thêm mới</Title>,
      children: <UserCreateView onClose={fetchData} />,
      size: "50%",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        //  left: ["mrt-row-select", "attachmentsCode"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    enableTopToolbar: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    fetchDataDepartment();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);

  useEffect(() => {
    getDepartmentSelect().then((x) => {
      setDataFetch(x);
    });
  }, []);
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex justify={"end"}>
            <div>
              <Button
                leftSection={<IconPlus size={14} />}
                variant="outline"
                mr={"xs"}
                onClick={handleCreateUser}
              >
                Thêm mới
              </Button>
            </div>
          </Flex>
        </Flex>
        <form>
          <Grid>
            <Grid.Col span={_span}>
              {" "}
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />{" "}
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Đơn vị"
                leftSection={<IconPencilUp color="#15aabf" />}
                placeholder="Chọn đơn vị"
                data={dataFetch.map((employee) => ({
                  value: employee.value,
                  label: employee.text,
                }))}
                limit={20}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                key={form.key(`departmentId`)}
                {...form.getInputProps("departmentId")}
                nothingFoundMessage="Không có dữ liệu"
                searchable
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default UserTable;
